import domReady from '@wordpress/dom-ready';
import SiteHeader from './site/shared/site-header/site-header';
// import './site/components/mobile-search-toggler';
import scrollbarWidthDetection from './site/utils/scrollbar-width-detection';
import osBrowserDetection from './site/utils/os-browser-detection';
import touchDeviceDetection from './site/utils/touch-device-detection';
// import ProductFilterToggle from './site/shared/woocommerce/filter-toggle';
import detectMainNavigationState from './site/main-navigation/main-navigation';
import CookiesConsent from './site/components/cookies-consent';

domReady(() => {
    // Inject scrollbar width CSS variable on root node
    scrollbarWidthDetection();

    // Detect device used by the user
    osBrowserDetection();
    
    // Detect if device can use touch events
    touchDeviceDetection();

    // Detect main navigation state and apply classes to the root node
    detectMainNavigationState();
    
    // Initialize the site header
    const siteHeader = document.querySelector('.site-header');
    if(siteHeader) {
        new SiteHeader(siteHeader, siteHeader.offsetHeight * 2);
    }

    // Cookie consent
    if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
      // Tarteaucitron cookie settings
      let tarteaucitronLang = "fr";

      const cookiesConsent = new CookiesConsent(tarteaucitronLang);
    }


    // Remove margins added by Gutenberg on headers wrappers nodes
    document.querySelectorAll('.site-header, .site-header-mobile').forEach((header) => {
        const headerWpWrapper = header.closest('.wp-block-template-part');
        if(headerWpWrapper) {
            headerWpWrapper.style.margin = 0;
        }
    });
}); 
// // ========================
// // Mega Menu JS simplifié (YITH-safe)
// // ========================

// function initMegaMenu() {
//   document.querySelectorAll('.wp-block-outermost-mega-menu').forEach(menu => {
//     // Évite le re-binding multiple
//     if (menu.dataset.bound) return;
//     menu.dataset.bound = 'true';

//     const toggle = menu.querySelector('.wp-block-outermost-mega-menu__toggle');
//     if (!toggle) return;

//     // Initialisation aria-expanded
//     if (!toggle.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded', 'false');

//     // ======================
//     // CLICK TOGGLE
//     // ======================
//     toggle.addEventListener('click', () => {
//       const expanded = toggle.getAttribute('aria-expanded') === 'true';

//       // Fermer tous les autres menus
//       document.querySelectorAll('.wp-block-outermost-mega-menu').forEach(otherMenu => {
//         if (otherMenu === menu) return;
//         const otherToggle = otherMenu.querySelector('.wp-block-outermost-mega-menu__toggle');
//         otherToggle?.setAttribute('aria-expanded', 'false');
//         otherMenu.classList.remove('is-open');
//       });

//       // Basculer le menu actuel
//       toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
//       menu.classList.toggle('is-open', !expanded);
//     });

//     // ======================
//     // FOCUS OUT / ESCAPE
//     // ======================
//     const menuContainer = menu.querySelector('.wp-block-outermost-mega-menu__menu-container');

//     menuContainer?.addEventListener('focusout', (event) => {
//       if (!event.relatedTarget || !menu.contains(event.relatedTarget)) {
//         toggle.setAttribute('aria-expanded', 'false');
//         menu.classList.remove('is-open');
//       }
//     });

//     menu.addEventListener('keydown', (event) => {
//       if (event.key === 'Escape') {
//         toggle.setAttribute('aria-expanded', 'false');
//         menu.classList.remove('is-open');
//         toggle.focus();
//       }
//     });
//   });
// }

// // ======================
// // Reposition menu
// // ======================
// function adjustMegaMenusSafe() {
//   if (typeof adjustMegaMenus === 'function') adjustMegaMenus();
// }

// // ======================
// // Initialisation
// // ======================
// document.addEventListener('DOMContentLoaded', () => {
//   initMegaMenu();
//   adjustMegaMenusSafe();
// });

// // ======================
// // Re-init après filtrage YITH AJAX
// // ======================
// jQuery(document).ajaxComplete(() => {
//   initMegaMenu();
//   adjustMegaMenusSafe();
// });
// jQuery(document).ajaxStop(() => {
//   initMegaMenu();
//   adjustMegaMenusSafe();
// });

// // ======================
// // Recalcul position au resize
// // ======================
// window.addEventListener('resize', adjustMegaMenusSafe);



// function initBurgerMenu() {
//     const burgerToggles = document.querySelectorAll('.wp-block-navigation__responsive-container-open');

//     burgerToggles.forEach(toggle => {
//         if (toggle.dataset.bound) return;
//         toggle.dataset.bound = 'true';

//         const menuContainer = toggle.closest('.wp-block-navigation');
//         const responsiveContainer = menuContainer?.querySelector('.wp-block-navigation__responsive-container');
//         const html = document.documentElement;

//         // Fonction pour ouvrir/fermer le menu
//         const setMenuState = (open) => {
//             toggle.setAttribute('aria-expanded', open);
//             menuContainer?.classList.toggle('is-open', open);
//             responsiveContainer?.classList.toggle('is-menu-open', open);
//             responsiveContainer?.classList.toggle('has-modal-open', open);
//             html.classList.toggle('has-modal-open', open);
//         };

//         // Toggle click
//         toggle.addEventListener('click', () => {
//             const isOpen = toggle.getAttribute('aria-expanded') === 'true';
//             setMenuState(!isOpen); // toggle
//         });

//         // Bouton close
//         const closeButton = responsiveContainer?.querySelector('.wp-block-navigation__responsive-container-close');
//         if (closeButton) {
//             closeButton.addEventListener('click', () => {
//                 setMenuState(false); // force fermeture
//             });
//         }

//         // Escape pour fermer
//         document.addEventListener('keydown', (event) => {
//             if (event.key === 'Escape') {
//                 setMenuState(false);
//             }
//         });
//     });
// }

// // ======================
// // Initialisation DOM Ready
// // ======================
// document.addEventListener('DOMContentLoaded', initBurgerMenu);

// // ======================
// // Ré-init après YITH AJAX
// // ======================
// jQuery(document).ajaxComplete(initBurgerMenu);
// jQuery(document).ajaxStop(initBurgerMenu);
